import React, { useEffect } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import { FloatFilter as FloatInputFilter } from 'components/common/CustomFilters/FloatFilter/FloatFilter';
import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: number[] | null | undefined;
    isSelected?: boolean;
}

export const FloatFilter = ({ name, methods, filtersStatusRef, handleFilters, value, isSelected = true }: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    return isSelected ? (
        <div className={classes.selectWrapper}>
            <Controller
                render={({ field }) => (
                    <FloatInputFilter
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            handleFilters?.();
                        }}
                        value={value}
                        label={FilterLabels.TOTAL_FLOAT_CARD_BOARD}
                    />
                )}
                name={name}
                control={methods?.control}
            />
        </div>
    ) : null;
};
